<template>
  <code-scanner @onDetected="detected" :identifier="$t('scanner.identifier.coin-card')" />
</template>

<script>
import { EventBus } from '@/helpers'
import { replaceCoinCardPrefix } from 'theme/helpers'
import CodeScanner from 'theme/components/CodeScanner/CodeScanner'

export default {
  name: 'CoinCardScanner',
  methods: {
    detected (data) {
      EventBus.$emit('coin-card-scanner::detect', replaceCoinCardPrefix(data.codeResult.code))
    }
  },
  components: {
    CodeScanner
  }
}
</script>
